__turbopack_context__.v({
  "className": "roboto_54c96945-module__EacW8W__className",
  "variable": "roboto_54c96945-module__EacW8W__variable",
});
